import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";

import { TenantActivityContext } from "../TenantActivityView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import ActivityLog from "../../../../components/ActivityLogComponent/ActivityLog";
import Loader from "../../../../components/Loader/Loader";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import InfiniteScroll from "react-infinite-scroll-component";

const TenantActivity = () => {
  const {
    spinnerStatus,
    errorPopup,
    errorPopupMessage,
    buttonText,
    tenantActivityList,
    formatDate,
    formatTime,
    currentPage,
    totalPage,
    goToTenantList,
    setErrorPopup,
    goToLogin,
    statusValue,
    tenantActivityListShow,
    hasMore,
  } = useContext(TenantActivityContext);
  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToTenantList}>
          {ContentData.tenantPage.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.activityRole}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <div className="pageTittles">
          {ContentData.rolePermissions.activityRole}
        </div>
        <div className="basicContainer adminTable profileInfoContainer ">
          <div className="dataActivityPage">
            <InfiniteScroll
              dataLength={tenantActivityList.length} // Total items currently loaded
              next={() => tenantActivityListShow(currentPage + 1)} // Load more data
              hasMore={hasMore} // Indicates if more data exists
              loader={<div className="loadingIndicator">Loading...</div>} // Loader
              endMessage={
                <p style={{ textAlign: "center" }}>No more activity logs</p>
              }
            >
              {tenantActivityList.map((item, index) => (
                <ActivityLog
                  key={index}
                  name={item?.name || "-"}
                  date={item?.createdAt ? formatDate(item.createdAt) : "-"}
                  time={item?.createdAt ? formatTime(item.createdAt) : "-"}
                  activityMessage={item?.description || "-"}
                />
              ))}
            </InfiniteScroll>
          </div>
        </div>
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            tenantActivityListShow();
          }
        }}
      />
    </div>
  );
};

export default TenantActivity;
